module.exports = __webpack_public_path__ + "img/historia_3-4_1152.5bc3c925.jpg";